'use client';
// Menú del teléfono (≤760 px): en pantallas pequeñas el menú de arriba se
// oculta para que quepan «Entrar» y «Pruébalo gratis»; este botón lo reemplaza.
import { useEffect, useId, useState } from 'react';
import './MenuMovil.css';

export default function MenuMovil({ enlaces }) {
  const [abierto, setAbierto] = useState(false);
  const id = useId();

  useEffect(() => {
    if (!abierto) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setAbierto(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [abierto]);

  return (
    <div className="menu-movil">
      <button
        type="button"
        className="menu-movil-btn"
        aria-expanded={abierto}
        aria-controls={id}
        aria-label={abierto ? 'Cerrar menú' : 'Abrir menú'}
        onClick={() => setAbierto((v) => !v)}
      >
        <span className={`menu-movil-icono${abierto ? ' abierto' : ''}`} aria-hidden="true"><span /><span /><span /></span>
      </button>
      <nav id={id} aria-label="Menú" className={`menu-movil-panel${abierto ? ' abierto' : ''}`} hidden={!abierto}>
        {enlaces.map(({ href, texto, sub }) => (
          <a key={href} href={href} className={sub ? 'menu-movil-sub' : undefined} onClick={() => setAbierto(false)}>{texto}</a>
        ))}
      </nav>
    </div>
  );
}
